import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-salary-forms-5-26',
  templateUrl: './salary-forms-5-26.component.html',
  styleUrl: './salary-forms-5-26.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SalaryForms526Component {

}
